import type { FaireProductEntity } from "../../entity_types/product";

export const p_c4v376739z: FaireProductEntity = {
  token: "p_c4v376739z",
  type: "product",
  name: "Lavendula 3/4 Sleeve Boxy Knit Button Down Sweater Cardigan",
  brandToken: "b_t9mynp4xpd",
  brandName: "Lovesoft",
  imageUrl:
    "https://cdn.faire.com/fastly/2150e2040ad93d2918b171210e609b4e007af5cf6b42075ff0fdcfaf5d3f0034.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5d886d7f4ad9cf89dbbf110d768ac954eab7b5654b6240e86c8d3b273fe143ec.jpeg",
    "https://cdn.faire.com/fastly/43123e66bec7761867a4fe7c7ba951afb25edc952fe7f05a0d95d0e42cd0ce5a.jpeg",
    "https://cdn.faire.com/fastly/df41e593c60f94fc192f8d008b7c146413786f43141aec9ffd242b8cff98372d.jpeg",
    "https://cdn.faire.com/fastly/0c8264239e9bb0d9b3c486ad9d273bdfa994ec425cda3dd11f67ecd79db2d338.jpeg",
    "https://cdn.faire.com/fastly/48beedabf5e52c8a0aea5e77043dacc3fafcfce7eb7f61940106315474cd60bb.jpeg",
    "https://cdn.faire.com/fastly/dbfe206aa66ea4266e8070c3e52c0f3df0308768ed760134e6ebea8b008670d5.png",
    "https://cdn.faire.com/fastly/06869e9eba3b15b351e04aa679be31e6cf0b30c4677ee47ee514f434dc569f4b.png",
    "https://cdn.faire.com/fastly/c45643a0f0ae3acf630ab4fd3b21217baae74337cdbe844b5a85bd8c6d507893.png",
    "https://cdn.faire.com/fastly/666e10944a4de3b65452a85cdd79f50d3e2ceba1d1d0be72e2e80e4a3da5495e.png",
  ],
  priceDollars: 100,
  description:
    "\n * Boxy knit cardigan offers a relaxed, modern layering silhouette.\n3/4 sleeve design is perfect for transitional seasons.\nButton down cardigan provides easy wear with classic styling.\nSoft knit sweater cardigan pairs effortlessly with jeans or dresses. \n\nBrand labels are not included by default. If needed, please add them via this link ($0.50/pc): https://www.faire.com/product/p_kzks8vegvk",
  tags: [],
  msrpDollars: 200,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:27.026Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
